import {InjectionKey} from 'vue'

const getTransactionByUuidKey = Symbol() as InjectionKey<Function>

export {
    getTransactionByUuidKey,
}